var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 9V0H4V9H11ZM3 3H1V12H8V10H3V3Z","fill":"#929088"}));
}

Copy.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Copy;

Copy.default = Copy;
